export default function Snackbar() {
    return {
        MuiSnackbarContent: {
            styleOverrides: {
                root: {},
            },
        },
    };
}
//# sourceMappingURL=Snackbar.js.map